
export default {
  init() {

    $('<section class="support-nav-container"><div class="sticky-container"></div></section>').prependTo('div.content');

    if (window.matchMedia('(min-width: 40em)').matches) {
      $('<div class="support-images"></div>')
      .appendTo('.sticky-container');
    }

    $('#givememoney').on('click', function(e) {
        e.preventDefault();
        $('#donateform').submit();
    });


    $('<ul class="support-nav"></ul>')
    .appendTo('.sticky-container');

    $('.main > .wp-block-group').each(function(  ) {
      var newId = $(this).find('h1').attr('id');
      $(this)
      .attr('id', newId)
      .addClass(newId);
      var headlineContent = $(this).find('h1').html();
      $(this).find('h1')
        .appendTo('.support-nav')
        .replaceWith('<li class="' + newId + '"><a href="#' + newId +'">' + headlineContent + '</a>');

       if (window.matchMedia('(min-width: 40em)').matches) {
          $(this).find('figure')
          .addClass(newId)
          .appendTo('.support-images');
       }

      // $(this).find('.wp-block-group .wp-block-group__inner-container').each(function() {
      //   $(this).find('>*:not(h2, .wp-block-buttons, form, input)').wrapAll( '<div class="sub-container" />');
      //   $('<button class="sub-container-toggle">+</button>').appendTo($(this));
      // });

    });

    // $('.wp-block-group__inner-container .wp-block-group .sub-container-toggle, .wp-block-group__inner-container .wp-block-group h2').on('click', function() {
    //   if ($(this).siblings('.sub-container').css('display') == 'none' ) {
    //     $(this).parent().children('button').html('&#8212;');
    //   } else {
    //     $(this).parent().children('button').html('+');
    //   }
    //   $(this).siblings('.sub-container').slideToggle();
    // });


    function activateSection(classname) {
      console.log(classname);

      $('figure.active').css('z-index', 1);
      $('.active').removeClass('active');
      $(classname).addClass('active');
      $('figure.active').css('z-index', 9);
    }

    $('a').on('click', function(event) {
      if (this.hash !== '') {
        event.preventDefault();
        var hash = this.hash;
        var classname = hash.replace(/#/g, '.');
        activateSection(classname);
          $('html, body').animate({
            scrollTop: $(hash).offset().top,
          }, 800, function() {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        });
      }
    });

    var classname = ''
    if (window.location.hash) {
      classname = window.location.hash.replace(/#/g, '.');
    } else {
      classname = '.' + $('.wp-block-group').first().attr('id');
    }
    console.log(classname);
    $(classname).addClass('active');



    $(document).bind('scroll',function(){
      $('.main > .wp-block-group').each(function(){
          if (
             $(this).offset().top < window.pageYOffset + 10
            //begins before top
          && $(this).offset().top + $(this).height() > window.pageYOffset + 10
             //but ends in visible area
              //+ 10 allows you to change hash before it hits the top border
          ) {
            if ($(this).attr('id') != 'support-bookworks') {
              window.location.hash = $(this).attr('id');
              classname = '.' + $(this).attr('id');
              activateSection(classname);
              console.log('jumped to ' + classname);
            } else if (window.scrollY < 500) {
              /* fix to stop it jumping around */
              window.location.hash = $(this).attr('id');
              classname = '.' + $(this).attr('id');
              activateSection(classname);
            }
          }
      });
  });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/support.js